import React from "react";
import Container from "@material-ui/core/Container";
import { Box, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  colorHighSchool,
  colorUniversity,
  colorUniversityCollectionOfExamples,
} from "../Theme/Theme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSchool,
  faUniversity,
  faBook,
} from "@fortawesome/free-solid-svg-icons";

const useStyles = makeStyles((theme) => {
  return {
    buttonSchool: {
      background: "#fff",
      borderRadius: theme.shape.borderRadius,
      borderStyle: "solid",
      borderWidth: 4,
      padding: theme.spacing(5, 2, 0),
      fontSize: 25,
      fontWeight: "bold",
      textTransform: "uppercase",
      textAlign: "center",
      cursor: "pointer",
      "& .icon": {
        fontSize: 160,
      },
      "&.small": {
        padding: theme.spacing(2.5, 1, 0),
        fontSize: 20,
        "& .icon": {
          fontSize: 80,
        },
      },
    },
    buttonSchoolUniversity: {
      borderColor: colorUniversity,
      color: colorUniversity,
      "&:hover, &.selected": {
        background: colorUniversity,
        color: theme.palette.primary.contrastText,
      },
    },
    buttonSchoolUniversityCollectionOfExamples: {
      borderColor: colorUniversityCollectionOfExamples,
      color: colorUniversityCollectionOfExamples,
      "&:hover, &.selected": {
        background: colorUniversityCollectionOfExamples,
        color: theme.palette.primary.contrastText,
      },
    },
    buttonSchoolHighSchool: {
      borderColor: colorHighSchool,
      color: colorHighSchool,
      "&:hover, &.selected": {
        background: colorHighSchool,
        color: theme.palette.primary.contrastText,
      },
    },
  };
});

const NotFound = () => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Container className={"landingPageView"} style={{ texAlign: "center" }}>
        <Typography
          variant={"h1"}
          style={{ fontSize: 60, fontWeight: 900, textAlign: "center" }}
        >
          404
        </Typography>
        <Typography variant={"h4"} style={{ textAlign: "center" }}>
          Kámo tyvoe, nevím, jak ses sem dostal, ale tady najdeš leda 💩.
        </Typography>
        <Typography
          variant={"h6"}
          style={{ textAlign: "center", marginTop: 32, marginBottom: 32 }}
        >
          Asis hledal něco z tohohle, ne?
        </Typography>

        <Grid
          container
          spacing={2}
          style={{
            marginTop: 8,
            marginBottom: 16,
            justifyContent: "center",
          }}
        >
          <Grid item sm={6} xs={12}>
            <Box
              className={[
                classes.buttonSchool,
                classes.buttonSchoolUniversity,
              ].join(" ")}
              onClick={() => {
                window.location.href = "/vysoka-skola";
              }}
            >
              <Box>DOUČOVÁNÍ VYSOKÁ ŠKOLA</Box>
              <Box className={"icon"}>
                <FontAwesomeIcon icon={faUniversity} />
              </Box>
            </Box>
          </Grid>

          <Grid item sm={6} xs={12}>
            <Box
              className={[
                classes.buttonSchool,
                classes.buttonSchoolUniversityCollectionOfExamples,
              ].join(" ")}
              onClick={() => {
                window.location.href = "/sbirky-prikladu";
              }}
            >
              <Box>FÍFOVY SBÍRKY PŘÍKLADŮ</Box>
              <Box className={"icon"}>
                <FontAwesomeIcon icon={faBook} />
              </Box>
            </Box>
          </Grid>

          <Grid item sm={6} xs={12}>
            <Box
              className={[
                classes.buttonSchool,
                classes.buttonSchoolHighSchool,
              ].join(" ")}
              onClick={() => {
                window.location.href = "/stredni-skola";
              }}
            >
              <Box>DOUČOVÁNÍ STŘEDNÍ ŠKOLA</Box>
              <Box className={"icon"}>
                <FontAwesomeIcon icon={faSchool} />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </React.Fragment>
  );
};

export default NotFound;
